function noop() {}

export {noop};
